export default __webpack_public_path__ + "static/media/user-harry.8b155db3.png";